// Replace all hyphens with non-breaking hyphens in brand names.
// Note: en and em dashes are already non-breaking, so don't need replacing:
// https://www.w3.org/wiki/Common_HTML_entities_used_for_typography

const hyphenSymbols = /-/g;

export const replaceHyphens = (brandName?: string) =>
  brandName?.replace(hyphenSymbols, '\u2011') || '';
